import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getForgotPasswordCheckPinCodePath = () => urlHelper(`/forgot-password/pin-code`);
